import { render, staticRenderFns } from "./detailCom.vue?vue&type=template&id=3f990902&scoped=true"
import script from "./detailCom.vue?vue&type=script&lang=js"
export * from "./detailCom.vue?vue&type=script&lang=js"
import style0 from "./detailCom.vue?vue&type=style&index=0&id=3f990902&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f990902",
  null
  
)

export default component.exports